import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
@Injectable({
  providedIn: 'root'
})
export class HighchartsService {

  constructor(private http_: HttpClient) { }

  createChart(el, cfg) {
    Highcharts.chart(el, cfg);
  }

  user: object  = { name: 'Arthur', age: 21 };
  
  updateJSON(){
    const blob = new Blob([JSON.stringify(this.user)], {type : 'application/json'});
    
    const options = {Headers, responseType: 'json' as 'blob'};
    this.http_.put('http://localhost:4200/assets/data/ex.json', {"user":"vimal"}, options).subscribe((data) => { 
         console.log(data);
    },(err: HttpErrorResponse) => {
      console.log (err.message);
    });
  }
}
